import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { TableBodyCell } from '../TableCell';
var rankingStyles = css(_templateObject());
export var RankableTableBodyCell = styled(TableBodyCell)(_templateObject2(), function (_ref) {
  var isRanking = _ref.isRanking;
  return isRanking && rankingStyles;
});